import Swal, { SweetAlertOptions } from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { inputMaskHelper } from "../../Lib/Helper/InputMaskHelper";
import { debounce } from "../../Lib/Helper/ProcessHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { BaseJsonResult } from "../../Models/Base";
import { AxChipcardHint } from "../../Utility/AxChipcardHint";
import { LocalizationModule } from "../Global/LocalizationModule";

@ModuleName('Reservation')
export class Reservation implements AxInit {
    private $parent: JQuery = $('[data-frontoffice-view="reservation"]')
    private initData!: InitData;
    private localization = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
    private request = new RequestHelper();
    private $wtpInput: JQuery = this.$parent.find('[data-reservation="input-wtp"]');
    private $serialInput: JQuery = this.$parent.find('[data-reservation="input-serial"]');
    private $manageWtpInput: JQuery = this.$parent.find('[data-reservation="manage-input-wtp"]');
    private $manageSerialInput: JQuery = this.$parent.find('[data-reservation="manage-input-serial"]');
    private $findButton: JQuery = this.$parent.find('[data-reservation="find"]')
    private axChipcardHint = new AxChipcardHint();
    private i18nHelper = new I18nHelper();
    private axLoading: AxLoading = new AxLoading();

    AxInit(init: InitData) {
        this.initData = init;
        const maskOptions = inputMaskHelper.wtpMaskOptions();

        this.$wtpInput.inputmask({
            ...maskOptions,
            clearIncomplete: true,
            mask: inputMaskHelper.wtpNumberMask(),
            oncomplete: () =>  this.$findButton.prop('disabled', false),
            onincomplete: () =>  this.$findButton.prop('disabled', true),
        });

        this.$serialInput.inputmask({
            ...maskOptions,
            clearIncomplete: true,
            mask: inputMaskHelper.numericNumberMask(this.initData.projNr),
            oncomplete: () => this.$findButton.prop('disabled', false),
            onincomplete: () => this.$findButton.prop('disabled', true),
        });

        this.$manageWtpInput.inputmask({
            ...maskOptions,
            clearIncomplete: true,
            mask: inputMaskHelper.wtpNumberMask(),
            oncomplete: () =>  this.$findButton.prop('disabled', false),
            onincomplete: () =>  this.$findButton.prop('disabled', true),
        });

        this.$manageSerialInput.inputmask({
            ...maskOptions,
            clearIncomplete: true,
            mask: inputMaskHelper.numericNumberMask(this.initData.projNr),
            oncomplete: () => this.$findButton.prop('disabled', false),
            onincomplete: () => this.$findButton.prop('disabled', true),
        });

        this.$parent
            .on('input', '[data-reservation*="input-"]', (e) => {
                const $current = $(e.currentTarget);
                this.$parent.find('[data-reservation*="input-"]').not($current).each((_, input) => {
                    $(input).val('').trigger('change');
                });
            })

            .on('click', '[data-reservation*="input-"] ~ i', (e) => {
                const type = $(e.currentTarget).attr('data-reservation-type') as string;
                this.axChipcardHint.ShowChipCardHint(type);
            })

            .on('click', 'label.chipcard-collapse-radio-label', (e) => {
                const $input = $(e.currentTarget).siblings('input');
                if (!$input.is(':checked')) {
                    $input.prop('checked', true);
                    this.$wtpInput.val('');
                    this.$serialInput.val('');
                    this.$manageWtpInput.val('');
                    this.$manageSerialInput.val('');
                }
            })

            .on('click reservation:manage','[data-reservation="make-button"], [data-reservation="manage-button"]', (e) => {
                const $clickedButton = $(e.currentTarget as HTMLElement);
                const $header = $clickedButton.closest('header');
                const actionType = ($clickedButton.attr('data-reservation') as string).replace('-button', '');
                const $containers = $header.siblings('[data-reservation$="-container"]');
                $header.find(`[data-reservation$="-button"]`).removeClass('ax-chip--active');
                $clickedButton.addClass('ax-chip--active');
                $containers.addClass('d-none');
                $header.siblings(`[data-reservation="${actionType}-container"]`).removeClass('d-none');
                $('[data-reservation="show-more"]').removeClass('d-none').siblings('div').addClass('collapsed');;
                this.calculateReservationsHeight();
            })

            .on('click', '[data-reservation="collapser"]', (e) => {
                const $wrapper = $(e.currentTarget).parent();
                $wrapper.toggleClass('collapsed');
                $wrapper.siblings('[data-reservation="wtp-tickets"]').toggleClass('collapsed');
                $('i')[$wrapper.hasClass('collapsed') ? 'addClass' : 'removeClass']('la-angle-down')
                $('i')[!$wrapper.hasClass('collapsed') ? 'addClass' : 'removeClass']('la-angle-up')
            })

            .on('click', '[data-reservation="now"]', (e) => {
                const useWtpOrSerial = this.getQuerystring();
                const ticket = $(e.currentTarget).attr('data-reservation-ticket') as string;
                const url = `/${this.localization.getSelectedLanguage()}/Reservation/Calendar/${ticket}${useWtpOrSerial}`;
                window.location.href = this.request.getFullUrl(url);
            })

            .on('click', '[data-reservation="find"]', (e) => {
                const useWtpOrSerial = this.getQuerystring();
                const hash = this.$manageWtpInput.toArray().some((e) => $(e).val() != '')
                    || this.$manageSerialInput.toArray().some((e) => $(e).val() != '') ? '#manage' : '';
                const url = `/${this.localization.getSelectedLanguage()}/Reservation${useWtpOrSerial}${hash}`;
                window.location.href = this.request.getFullUrl(url);
            })

            .on('click', '[data-reservation="show-more"]', (e) => {
                $(e.currentTarget).addClass('d-none').siblings('div.collapsed').removeClass('collapsed');
            })

            .on('click', '[data-reservation="reschedule"]', (e) => {
                const $button = $(e.currentTarget);
                const useWtpOrSerial = this.getQuerystring();
                const slot = $button.closest('div').attr('data-reservation-slot') as string;
                const ampOrQuestion = useWtpOrSerial ? '&' : '?';
                const useSlot = slot ? `${ampOrQuestion}slot=${slot}` : '';
                const ticket = $button.closest('div').attr('data-reservation-ticket') as string;
                const url = `/${this.localization.getSelectedLanguage()}/Reservation/Calendar/${ticket}${useWtpOrSerial}${useSlot}`;
                window.location.href = this.request.getFullUrl(url);
            })

            .on('click', '[data-reservation="cancel"]', (e) => {
                const $button = $(e.currentTarget);
                const data = {
                    ticketSerial: $button.closest('div').attr('data-reservation-ticket') as string,
                    slotTriple: $button.closest('div').attr('data-reservation-slot') as string,
                }
                const alertHTML = $('<div>', { class: 'ax-border ax-border-radius ax-p-2 text-left' }).append(
                    $('<p>', { class: 'text-h4' }).text($button.closest('div').attr('data-reservation-name') as string),
                    $('<span>', { class: 'text-caption ax-color-gray-500' }).text(this.i18nHelper.GetTranslation(Translations.ReservationFor)),
                    $('<p>', { class: 'text-body-2-500' }).text($button.closest('div').attr('data-reservation-date') as string),
                    $('<span>', { class: 'text-caption ax-color-gray-500' }).text(this.i18nHelper.GetTranslation(Translations.Person)),
                    $('<p>', { class: 'text-body-2-500' }).text($button.closest('div').attr('data-reservation-person') as string),
                ).prop('outerHTML');
                Swal.fire({
                    title: `${this.i18nHelper.GetTranslation(Translations.ReservationCancel)}?`,
                    customClass: {
                        container: 'ax-reservation',
                        cancelButton: 'ax-btn ax-btn-secondary text-center',
                        confirmButton: 'ax-btn ax-btn-primary text-center',
                        htmlContainer: 'ax-px-4 ax-m-0',
                        actions: 'w-100 ax-px-4',
                    },
                    html: alertHTML,
                    showCancelButton: true,
                    icon: 'error',
                    didRender: (popup) => {
                        $(popup).find('button').removeClass('swal2-styled swal2-confirm swal2-cancel');
                    },
                    cancelButtonText: this.i18nHelper.GetTranslation(Translations.Cancel),
                    confirmButtonText: this.i18nHelper.GetTranslation(Translations.Confirm),
                    reverseButtons: true,
                } as SweetAlertOptions).then((res) => {
                    if (res.value) {
                        AxessViewer.loadPartialView('/Reservation/CancelReservation', data, (res: BaseJsonResult) => {
                            if (res.success) {
                                this.axLoading.ShowLoadingIndicatorFixed($('[data-reservation="make-container"]').get(0) as HTMLElement);
                                this.axLoading.ShowLoadingIndicatorFixed($('[data-reservation="manage-container"]').get(0) as HTMLElement);
                                window.location.reload();
                            } else {
                                Swal.fire({
                                    title: this.i18nHelper.GetTranslation(Translations.Error),
                                    text: res.message,
                                    confirmButtonText: this.i18nHelper.GetTranslation(Translations.Ok),
                                } as SweetAlertOptions).then((res) => window.location.reload());
                            }
                        }, {
                            silent: true,
                        });
                    }
                });
            });


        const url = new URL(window.location.href)
        if (url.hash === '#manage') {
            this.$parent.find('[data-reservation="manage-button"]').trigger('reservation:manage');
        }

        this.calculateReservationsHeight();
        $(window).on('resize orientationchange', debounce(100) (() => this.calculateReservationsHeight()));

        $('window').on('load', () => {
            this.$parent.find('input[type="radio"]')
        })
    }

    getQuerystring() {
        const serialVal = this.$serialInput.filter((_, el) => $(el).val() != '').val() as string;
        const manageSerialVal  = this.$manageSerialInput.filter((_, el) => $(el).val() != '').val() as string;
        const wtpVal = this.$wtpInput.filter((_, el) => $(el).val() != '').val() as string;
        const manageWtpVal  = this.$manageWtpInput.filter((_, el) => $(el).val() != '').val() as string;
        const serialValue = serialVal ? serialVal : manageSerialVal;
        const wtpValue = wtpVal ? wtpVal : manageWtpVal;
        const serial = serialValue ? `?serial=${(serialValue as string).replace(/\//g, '-')}` : '';
        const wtp = wtpValue ? `?wtp=${wtpValue as string}` : '';
        return (wtp.length > 0 && wtp) || (serial.length > 0 && serial) || '';
    }

    calculateReservationsHeight() {
        setTimeout(() => {
            const $container = this.$parent.find('[data-reservation="wtp-tickets"]');
            $container.each((_, el) => {
                const $collapsed = $(el).children('div');
                let totalHeight = 0;
                $collapsed.children().slice(0, 3).each((_, ele) => {
                    totalHeight += $(ele).height() as number + 48;
                });
                $collapsed.css({ 'max-height': `${totalHeight}px` });
            });
        });
    }
}

interface InitData {
    projNr: number;
    userSignedIn: boolean;
}
